<template>
  <div class="date-presets">
    <div
      v-for="preset in presets"
      :key="preset.key"
      :class="['date-presets__item', active === preset.key && 'date-presets__item--active']"
      @click="choose(preset)"
    >
      {{ $t("datePresets." + preset.key) }}
    </div>
  </div>
</template>

<script>
import moment from "moment";

/**
 * Стандартные периоды для отчётов. Компонент не знает, в какие поля страница
 * складывает даты: он отдаёт готовую пару { from, to } объектами Date, а
 * страница сама пишет их в свой filterData и дёргает свой фильтр.
 */
export default {
  name: "DateRangePresets",
  props: {
    // с каким пресетом компонент отрисуется выбранным
    selected: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      active: this.selected,
      presets: [
        { key: "today", range: () => [moment(), moment()] },
        { key: "last7", range: () => [moment().subtract(6, "days"), moment()] },
        { key: "last30", range: () => [moment().subtract(29, "days"), moment()] },
        { key: "last60", range: () => [moment().subtract(59, "days"), moment()] },
        { key: "thisWeek", range: () => [moment().startOf("isoWeek"), moment()] },
        {
          key: "lastWeek",
          range: () => [
            moment().subtract(1, "week").startOf("isoWeek"),
            moment().subtract(1, "week").endOf("isoWeek"),
          ],
        },
        { key: "thisMonth", range: () => [moment().startOf("month"), moment().endOf("month")] },
        {
          key: "lastMonth",
          range: () => [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      ],
    };
  },
  watch: {
    selected(value) {
      this.active = value;
    },
  },
  methods: {
    choose(preset) {
      const [from, to] = preset.range();

      this.active = preset.key;

      this.$emit("select", {
        key: preset.key,
        from: from.startOf("day").toDate(),
        to: to.endOf("day").toDate(),
      });
    },
    // период пресета без клика — нужен странице для начального состояния
    rangeOf(key) {
      const preset = this.presets.find((item) => item.key === key);

      if (!preset) {
        return null;
      }

      const [from, to] = preset.range();

      return { key, from: from.startOf("day").toDate(), to: to.endOf("day").toDate() };
    },
  },
};
</script>

<style lang="scss" scoped>
.date-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;

  &__item {
    padding: 6px 10px;
    border: 1px solid #131313;
    border-radius: 5px;
    background: $g-color-white;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;

    &:hover {
      background: #ededed;
    }

    &--active {
      background: #131313;
      color: $g-color-white;
    }
  }
}
</style>
